import React from 'react';
import MultipleChoice from './MultipleChoice';
import OpinionScale from './OpinionScale';
import ShortText from './ShortText';
import NumberInput from './NumberInput';

const typeformTypes = {
  MULTIPLE_CHOICE: 'multiple_choice',
  OPINION_SCALE: 'opinion_scale',
  SHORT_TEXT: 'short_text',
  NUMBER: 'number'
};

export const Question = ({ item, questions, onChange }) => {
  const question = questions.find(q => q.id === item.id);

  if (item.type === typeformTypes.MULTIPLE_CHOICE) {
    return <MultipleChoice result={item} question={question} onChange={onChange} />;
  }

  if (item.type === typeformTypes.OPINION_SCALE) {
    return <OpinionScale result={item} question={question} onChange={onChange} />;
  }

  if (item.type === typeformTypes.SHORT_TEXT) {
    return <ShortText result={item} question={question} onChange={onChange} />;
  }

  if (item.type === typeformTypes.NUMBER) {
    return <NumberInput result={item} question={question} onChange={onChange} />;
  }

  return null;
};
